import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';
import ProvidersButton from '@/components/filter-bar/ProvidersButton.vue';
import FilterBarProvider from '@/components/filter-bar/FilterBarProvider.vue';
import TitleListSortingSwitcher from '@/components/list/sorting/TitleListSortingSwitcher.vue';

import { faPlus, faShare, faCheck } from '@fortawesome/free-solid-svg-icons';
import { CollectionType } from '@/enums/collection-type';
import { TitleObjectType } from '@/interfaces/titles';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleListFilter',
  props: {
    activeContentType: null,
    hasMixedObjectTypes: { type: Boolean },
    isFollowed: { type: Boolean }
  },
  emits: ["toggleContentType", "addTitles", "shareList"],
  setup(__props: any) {





const filterStore = useFilterStore();
const languageStore = useLanguageStore();

const showProviders = ref(false);

return { __sfc: true,filterStore, languageStore, showProviders, BasicButton, ProvidersButton, FilterBarProvider, TitleListSortingSwitcher, faPlus, faShare, faCheck, CollectionType, TitleObjectType }
}

})